import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocked = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.39 9.00127H15.5875V6.75049C15.5499 5.45722 14.9932 4.23134 14.0395 3.34126C13.0857 2.45119 11.8125 1.96946 10.4988 2.00157C9.18455 1.9688 7.91073 2.45023 6.95642 3.34037C6.00211 4.23052 5.44512 5.45679 5.4075 6.75049V9.00004H4.6075C4.19237 8.98945 3.78993 9.14147 3.48855 9.42273C3.18716 9.70398 3.01145 10.0915 3 10.5002V16.4994C3.01145 16.908 3.18716 17.2955 3.48855 17.5768C3.78993 17.858 4.19237 18.0101 4.6075 17.9995H16.3925C16.8076 18.0101 17.2101 17.858 17.5115 17.5768C17.8128 17.2955 17.9885 16.908 18 16.4994V10.5002C17.9882 10.0917 17.8124 9.70451 17.511 9.42352C17.2097 9.14253 16.8074 8.99068 16.3925 9.00127H16.39ZM12.9075 9.00127H8.08625V6.75049C8.12063 6.1438 8.38966 5.57309 8.83808 5.15557C9.28651 4.73805 9.88029 4.5054 10.4975 4.5054C11.1147 4.5054 11.7085 4.73805 12.1569 5.15557C12.6053 5.57309 12.8744 6.1438 12.9088 6.75049L12.9075 9.00127Z",
		fill: "#0D2976"
	})
});
export default SvgLocked;
